import { Stack, Typography } from "@mui/material";

import { DashboardBackButton } from "components/Shipment/components/DashboardBackButton";

import { QuickSupplierShipmentsBrowser } from "../QuickSupplierShipmentsBrowser";

interface Props {
  supplierShipments: SupplierShipment[];
  shipmentSelectionIsDisabled: boolean;
  handlePageSelected: (e: React.ChangeEvent<unknown>, value: number) => void;
  page: number;
  pages: number;
  shipmentCount: number;
  showDashboardBackButton?: boolean;
}

export function SupplierShipmentsSidebar(props: Props) {
  const {
    supplierShipments,
    shipmentSelectionIsDisabled,
    handlePageSelected,
    page,
    pages,
    shipmentCount,
    showDashboardBackButton = true,
  } = props;

  return (
    <Stack direction="column">
      {showDashboardBackButton && <DashboardBackButton />}
      <Typography variant="h6" mb="0.5rem">
        Supplier Shipments ({shipmentCount ?? "-"})
      </Typography>
      <QuickSupplierShipmentsBrowser
        supplierShipments={supplierShipments}
        shipmentSelectionIsDisabled={shipmentSelectionIsDisabled}
        page={page}
        pages={pages}
        handlePageSelected={handlePageSelected}
      />
    </Stack>
  );
}
